import { render, staticRenderFns } from "./CameraView.vue?vue&type=template&id=5f013698&scoped=true"
import script from "./CameraView.vue?vue&type=script&lang=js"
export * from "./CameraView.vue?vue&type=script&lang=js"
import style0 from "./CameraView.vue?vue&type=style&index=0&id=5f013698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f013698",
  null
  
)

export default component.exports